import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import paymentDetailsApi from '../../sources/api/paymentDetailsAPI';

// constants
import { UPDATE_PAYMENT_DETAILS } from '../../constants/paymentDetailsTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { paymentDetailsSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { UPDATE_PAYMENT_DETAILS_SUCCESS, UPDATE_PAYMENT_DETAILS_ERROR } from '../../constants/messages';

export function* updatePaymentDetails(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(UPDATE_PAYMENT_DETAILS, call(paymentDetailsApi.updatePaymentDetails, params), paymentDetailsSchema);
    yield toastr.success('success', UPDATE_PAYMENT_DETAILS_SUCCESS);
  } catch (e) {
    yield toastr.error(UPDATE_PAYMENT_DETAILS_ERROR);
    yield put(error(UPDATE_PAYMENT_DETAILS, e));
  } finally {
    yield put(doneIndicator(UPDATE_PAYMENT_DETAILS));
  }
}

export function* watchUpdatePaymentDetails() {
  yield takeEvery(UPDATE_PAYMENT_DETAILS, updatePaymentDetails);
}

export default function* root() {
  yield all([
    fork(watchUpdatePaymentDetails)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/paymentDetails/updatePaymentDetails.js